<template>
    <div class="min-h-screen bg-surface-sunken relative">
        <div class="flex flex-wrap items-center justify-end gap-3 px-6 pt-6 sm:px-10 sm:pt-10">
            <img
                v-if="orgLogoUrl"
                :src="orgLogoUrl"
                :alt="t('components.rater.logoAlt', { organization: orgName ?? t('components.rater.organization') })"
                class="h-5 max-w-[80px] object-contain" />
            <span class="details text-ink-muted">{{ t("components.rater.poweredBy") }}</span>
            <span v-if="showAnonymous" class="details text-ink-muted flex items-center gap-2 pl-3 border-l border-border-strong">
                <i class="bi bi-shield-lock" aria-hidden="true"></i> {{ t("components.rater.anonymous") }}
            </span>
            <span v-else class="details text-ink-muted flex items-center gap-2 pl-3 border-l border-border-strong">
                <i class="bi bi-person-circle" aria-hidden="true"></i> {{ t("components.rater.signedIn") }}
            </span>
        </div>

        <main class="mx-auto w-full px-6 sm:px-10 pt-10 pb-10 flex flex-col gap-6" :style="{ maxWidth: maxWidth + 'px' }">
            <slot />
        </main>
    </div>
</template>

<script setup lang="ts">
import type { OrganizationDetails } from "~vue/appTypes";
import { computed, inject, type Ref } from "vue";
import { useI18n } from "vue-i18n";

const { t } = useI18n();

interface Props {
    maxWidth?: number;
    // Pages pass `!invite.is_authenticated` here so authenticated visitors see
    // "Signed in" instead of the anonymity chip. Defaults to true so anyone
    // who lands on a rater page pre-invite-fetch sees the safer default.
    showAnonymous?: boolean;
}

withDefaults(defineProps<Props>(), {
    maxWidth: 640,
    showAnonymous: true,
});

const organizationDetails = inject<Ref<OrganizationDetails | null>>("organization_details");
const orgLogoUrl = computed(() => organizationDetails?.value?.logo_url ?? null);
const orgName = computed(() => organizationDetails?.value?.name ?? null);
</script>
